import { apiGetAuth, apiPostAuth, apiPutAuth, apiDeleteAuth } from '@/utils/api'
import { API_CAMPAIGN, API_USER_MANAGEMENT, API_MASTER_DATA } from '@/utils/api-url'
import router from '@/router'
import {
  notificationDanger
} from '@/utils/notification'

const state = () => {
  return {
    detail_user: { data: []},
    pos_promo_code: { data: []},
    list_store: { data: []},
    tags: { data: [] },
    campaigns: { data: [] },
    offers: { data: [] },
    consumer_offers: { data: [] },
    offers_all: { data: [] },
    detail_offer: { data: {}},
    calculate_tag: { data: {}},
    meta_filter: {},
    data_modal_add_edit: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,
      title: '',
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loadingTable: false,
      loadingPopUp: false
    }
  }
}

const mutations = {
  SET_DETAIL_USER (state, payload) {
    state.detail_user = payload
  },
  SET_LIST_PROMO_CODE (state, payload) {
    state.pos_promo_code = payload
  },
  SET_LIST_STORE (state, payload) {
    state.list_store = payload
  },
  SET_TAG (state, payload) {
    state.tags = payload
  },
  SET_CAMPAIGN (state, payload) {
    state.campaigns = payload
  },
  SET_OFFER (state, payload) {
    state.offers = payload
  },
  SET_CONSUMER_OFFER (state, payload) {
    state.consumer_offers = payload
  },
  SET_OFFER_ALL (state, payload) {
    state.offers_all = payload
  },
  SET_DETAIL_OFFER (state, payload) {
    state.detail_offer = payload
  },
  SET_CALCULATE_TAG (state, payload) {
    state.calculate_tag = payload
  },
  SET_META_FILTER (state, payload) {
    state.meta_filter = payload
  },
  SET_DATA_MODAL_ADD_EDIT (state, payload) {
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD (state, payload) {
    state.toggle_modal_add_edit_discard = payload
  }
}

const actions = {
  async getPromoCode (context, payload) {
    try {
      const response = await apiPostAuth(API_CAMPAIGN.GET_PROMO_CODE, payload)
      context.commit('SET_LIST_PROMO_CODE', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListStoreFromGroupStore (context, payload) {
    try {
      const response = await apiPostAuth(API_MASTER_DATA.LIST_STORE_FROM_GROUP_STORE(payload.params), payload.data)
      context.commit('SET_LIST_STORE', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListAllTag (context, payload) {
    try {
      const response = await apiGetAuth(API_CAMPAIGN.LIST_ALL_TAG, payload)
      context.commit('SET_TAG', response.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListCampaign (context, payload) {
    try {
      const response = await apiGetAuth(API_CAMPAIGN.LIST_CAMPAIGN, payload)
      context.commit('SET_CAMPAIGN', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListAllDetailUser (context, payload) {
    try {
      const response = await apiPostAuth(API_USER_MANAGEMENT.ALL_USERNAME, payload)
      context.commit('SET_DETAIL_USER', response.data.data)
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async getListOffer (context, payload) {
    try {
      const response = await apiGetAuth(API_CAMPAIGN.LIST_OFFER, payload)
      context.commit('SET_OFFER', response.data.data)
      context.commit('SET_META_FILTER', payload)
      router.push({ name: 'Offers', query: payload })
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async getListConsumerOffer (context, payload) {
    try {
      const response = await apiGetAuth(API_CAMPAIGN.LIST_CONSUMER_OFFER, payload)
      context.commit('SET_CONSUMER_OFFER', response.data.data)
      context.commit('SET_META_FILTER', payload)
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async getListOfferAll (context, payload) {
    try {
      const response = await apiGetAuth(API_CAMPAIGN.LIST_ALL_OFFER, payload)
      context.commit('SET_OFFER_ALL', response.data.data)
      context.commit('SET_META_FILTER', payload)
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async getDetailOffer (context, payload) {
    try {
      const response = await apiGetAuth(API_CAMPAIGN.DETAIL_OFFER(payload))
      context.commit('SET_DETAIL_OFFER', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async calculateTag (context, payload) {
    try {
      const response = await apiPostAuth(API_CAMPAIGN.CALCULATE_TAG, payload)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async createOffer (context, payload) {
    try {
      const response = await apiPostAuth(API_CAMPAIGN.CREATE_OFFER, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async updateOffer (context, payload) {
    try {
      const response = await apiPutAuth(API_CAMPAIGN.UPDATE_OFFER(payload.id), payload.reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async deleteOffer (context, payload) {
    try {
      const response = await apiDeleteAuth(API_CAMPAIGN.DELETE_OFFER(payload))
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  detail_user (state) {
    return state.detail_user
  },
  list_promo_code (state) {
    return state.pos_promo_code
  },
  list_store (state) {
    return state.list_store
  },
  list_all_tag (state) {
    return state.tags
  },
  list_campaign (state) {
    return state.campaigns
  },
  list_offer (state) {
    return state.offers
  },
  list_consumer_offer (state) {
    return state.consumer_offers
  },
  list_all_offer (state) {
    return state.offers_all
  },
  detail_offer (state) {
    return state.detail_offer
  },
  get_data_modal_add_edit (state) {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard (state) {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter (state) {
    return state.meta_filter
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
